export default "__VITE_ASSET__0887c7fc__"